import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { maintenanceAction, authActions } from "../../_store";
import {
  DateInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button.jsx";
import Table from "../../components/common/table/Table";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch";
import { fDate, MinDate } from "../../utils/formatTime.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import ManagementUser from "./../ManagementUser/ManagementUserList";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import maintanenceShema from "../../validation/maintanenceSchema.js";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import PaymentGatewayMaintenance from "./PaymentGatewayMaintenance";
import { StoredProcedures } from "../../_helpers/enumerator";

function ApplicationMaintenance({ key }) {
  const { applicationMaintenanceList, loading } = useSelector(
    (x) => x.maintenance
  );

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const dispatch = useDispatch();

  // const [pagination, setPagination] = useState({
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  // });

  const [appmaintanence, setAppmaintanence] = useState({
    ApplicationMaintenceID: 0,
    MaintanenceAlert: "",
    FromDate: "",
    ToDate: "",
    CreatedBy: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortBy: "MaintanenceAlert DESC",
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    handleReset();
  }, [key]);

  useEffect(() => {
    dispatch(
      maintenanceAction.LoadApplicationMaintenanceList({
        PageNo: appmaintanence?.PageNo,
        RowCountPerPage: appmaintanence?.RowCountPerPage,
        SortBy: "MaintanenceAlert DESC",
      })
    );
    setAppmaintanence({
      ...appmaintanence,
      CreatedBy: user.ManagementUserID,
    });
  }, [appmaintanence.PageNo, appmaintanence.RowCountPerPage, isPageReloading]);

  const columns = [
    {
      width: "150px",
      key: "MaintanenceAlert",
      name: "Maintenance Alert",
      selector: (row) => row.MaintanenceAlert,
      sortable: true,
    },
    {
      key: "FromDate",
      name: "From Date",
      selector: (row) => row.FromDate,
      sortable: true,
    },
    {
      key: "ToDate",
      name: "To Date",
      selector: (row) => row.ToDate,
      sortable: true,
    },
    {
      key: "CreatedDate",
      name: "Created Date ",
      selector: (row) => row.CreatedDate,
      sortable: true,
    },
    {
      key: "ModifiedDate",
      name: "Modified Date",
      selector: (row) => row.ModifiedDate,
      sortable: true,
    },
    {
      key: "Status",
      name: "Status",
      selector: (row) => row.Status,
      sortable: true,
      cell: (row, index) => (
        <div
          onClick={(e) => {
            if (row.Status === 0) {
              showToastNotification(
                "You can't enable this Alert Message",
                "error"
              );
              return; // Prevent further execution
            }
          }}
        >
          <ToggleSwitch
            name={`Status${row.ApplicationMaintenceID}`}
            id={`Status${row.ApplicationMaintenceID}`}
            checked={row.Status}
            value={row.Status}
            disabled={row.Status === 0}
            handleClick={(e) => handleCheckboxClick(index, e, row)}
          />
        </div>
      ),
    },
  ];

  const handleCheckboxClick = (index, e, row) => {
    const { checked } = e?.target;

    Popup({
      title: "Message",
      text: `Are you sure you want to Disable?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        dispatch(
          maintenanceAction.UpdateMaintenanceStatus({
            ApplicationMaintenceID: row.ApplicationMaintenceID,
            Status: checked ? 1 : 0,
            ModifiedBy: user.ManagementUserID,
          })
        ).then((res) => {
          if (res.payload?.IsSucceed === 1 || 2) {
            dispatch(
              maintenanceAction.LoadApplicationMaintenanceList({
                PageNo: appmaintanence?.PageNo,
                RowCountPerPage: appmaintanence?.RowCountPerPage,
                SortBy: "MaintanenceAlert DESC",
              })
            );
            showToastNotification("Status disabled successfully.", "success");
          } else if (res.payload?.IsSucceed === -1) {
            showToastNotification(
              "Once disabled, the status cannot be enabled again.",
              "error"
            );
          }
        });
      },
    });
  };

  const handleChanePageNo = (value) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    setAppmaintanence((prev) => ({
      ...prev,
      PageNo: value,
    }));
  };

  const handleRowPerPage = (value) => {
    setAppmaintanence({
      ...appmaintanence,
      PageNo: 1,
      RowCountPerPage: value,
    });
  };

  const [submitted, setSubmitted] = useState(false);

  const handleMaintenanceChange = (e) => {
    let { name, value } = e.target;

    // Trim only the start of the input value
    let trimmedValue = value.trimStart();

    // Update the state
    setAppmaintanence((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    // Clear the error message if there's no validation error
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Remove the error class from the input field
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      element.classList.remove("input-error");
    }
  };

  const handleDateChange = (date, name) => {
    let formattedDate = date ? fDate(date) : ""; // Format the date

    // Update the state with the new date value
    setAppmaintanence((prev) => ({
      ...prev,
      [name]: formattedDate,
    }));

    // Clear the error message if there's no validation error
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Remove the error class from the input field
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      element.classList.remove("input-error");
    }
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && appmaintanence[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);

    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    const { error } = maintanenceShema(appmaintanence, false);
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(
          `input[name="${path}"], textarea[name="${path}"], DatePicker[name="${path}"]`
        );
        if (inputElement) {
          // Add the input-error class if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    Popup({
      title: "Message",
      text: `Are you sure you want to Submit?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      // onConfirm: () => dispatch(documentsActions.DeleteDocument(payload)),
      onConfirm: () => {
        dispatch(maintenanceAction.AddMaintenanceSchedule(appmaintanence))
          .then((res) => {
            if (res.payload?.IsSucceed === 1) {
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.InsertUpdateApplicationMaintanence,
                  UserAction: `Added a Maintanence Information ( Alert - ${appmaintanence?.MaintanenceAlert} )`,
                })
              );

              // Accessing `payload` properly

              setAppmaintanence((prev) => ({
                ...prev,
                MaintanenceAlert: "",
                FromDate: "",
                ToDate: "",
              }));
              dispatch(
                maintenanceAction.LoadApplicationMaintenanceList({
                  PageNo: 1,
                  RowCountPerPage: 10,
                  SortBy: "MaintanenceAlert DESC",
                })
              );
              showToastNotification(
                "Application Maintenance Information saved successfully.",
                "success"
              );
            } else if (res.payload?.IsSucceed === -1) {
              // Optional: Handle case where `IsSucceed` is not 1
              showToastNotification(
                "Something went wrong. Please try again.",
                "error"
              );
            }
          })
          .catch((error) => {
            console.error("Error adding maintenance schedule:", error);
          });
      },
    });
  };

  const handleReset = () => {
    setErrorMessage({});
    setSubmitted(false);

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    setAppmaintanence((prev) => ({
      ...prev,
      MaintanenceAlert: "",
      FromDate: "",
      ToDate: "",
      PageNo: 1,
      RowCountPerPage: 10,
    }));
    dispatch(
      maintenanceAction.LoadApplicationMaintenanceList({
        PageNo: 1,
        RowCountPerPage: 10,
        SortBy: "MaintanenceAlert DESC",
      })
    );
  };

  const handleBlur = (e) => {
    let { name, value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (name === "FromDate") {
      if (
        appmaintanence.ToDate &&
        new Date(value) > new Date(appmaintanence.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (name === "ToDate") {
      if (
        appmaintanence.FromDate &&
        new Date(value) < new Date(appmaintanence.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    // const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate;

    let updatedParam = {
      ...appmaintanence,
      FromDate:
        name === "FromDate"
          ? isFromValid && isValidDate
            ? fDate(value)
            : ""
          : appmaintanence.FromDate, // preserve existing value
      ToDate:
        name === "ToDate"
          ? isToValid && isValidDate
            ? fDate(value)
            : ""
          : appmaintanence.ToDate, // preserve existing value
    };

    setAppmaintanence(updatedParam);
    if (submitted) {
      // Perform validation using the schema
      const { error } = maintanenceShema(appmaintanence, false);

      if (error?.details) {
        // Extract the error message for the specific field
        const fieldError = error.details.find(
          (e) => e.path.toString() === name
        );

        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
        }));

        // Select the input element
        const element = document.querySelector(`[name="${name}"]`);

        if (element) {
          if (fieldError) {
            // Add the error class if there's a validation issue
            element.classList.add("input-error");
          } else {
            // Remove the error class if validation passes
            element.classList.remove("input-error");
          }
        }
      } else {
        // Clear the error message if there's no validation error
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "",
        }));

        // Remove the error class from the input field
        const element = document.querySelector(`[name="${name}"]`);
        if (element) {
          element.classList.remove("input-error");
        }
      }
    }
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;

    const search = { ...appmaintanence };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortBy = `${column.key} ${newSortOrder}`;
    setAppmaintanence(search);
    dispatch(
      maintenanceAction.LoadApplicationMaintenanceList({
        PageNo: appmaintanence?.PageNo,
        RowCountPerPage: appmaintanence?.RowCountPerPage,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="card b-r-all  p-4 mb-3">
        <h4 className="form_title_uppercase text-color">
          Application Maintenance Schedule Information
        </h4>

        <div>
          <form onSubmit={handleSubmit}>
            {/* <div className="row"> */}
            <div className="mb-1 ">
              <TextAreaInput
                name="MaintanenceAlert"
                id="MaintanenceAlert"
                label=" Maintenance Alert"
                value={appmaintanence?.MaintanenceAlert}
                handleChange={handleMaintenanceChange}
                placeholder=""
                required
                errorMessage={errorMessage}
                rows={3} // Number of rows for the textarea
                disabled={false}
                maxLength={100}
                handleBlur={handleBlur}
              />
            </div>
            <div className="row col-lg-12">
              <div className="mb-1 col-lg-6">
                <DateInput
                  name="FromDate"
                  label="From Date"
                  maxDate={appmaintanence?.ToDate}
                  value={appmaintanence?.FromDate}
                  handleChange={(date) => handleDateChange(date, "FromDate")}
                  required
                  errorMessage={errorMessage}
                  handleBlur={handleBlur}
                  isClearable={appmaintanence?.FromDate ? true : false}
                  handleKeyDown={(e) => handleDateEnterKey(e, "FromDate")}
                />
              </div>
              <div className="mb-1 col-lg-6">
                <DateInput
                  name="ToDate"
                  label="To Date"
                  minDate={appmaintanence?.FromDate}
                  // maxDate={new Date()}
                  value={appmaintanence?.ToDate}
                  handleChange={(date) => handleDateChange(date, "ToDate")}
                  required
                  errorMessage={errorMessage}
                  handleBlur={handleBlur}
                  isClearable={appmaintanence?.ToDate ? true : false}
                  handleKeyDown={(e) => handleDateEnterKey(e, "ToDate")}
                />
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-3 gap-3">
              <Button
                className="me-2"
                label={"Save"}
                type="submit"
                variant="danger"
                icon={"fa-solid fa-floppy-disk"}
                status={"success"}
                disabled={false}
              />
              <Button
                className="me-2"
                label="Reset"
                type="reset"
                variant="danger"
                icon={"fa-solid fa-rotate-right"}
                status={"secondary"}
                onClick={handleReset}
                disabled={false}
              />
            </div>
          </form>
        </div>
      </div>

      <div className="mt-5">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
          <h4 className="form_title_uppercase text-color">
            Application Maintenance HISTORY
          </h4>
        </div>

        <Table
          columns={columns}
          data={applicationMaintenanceList.DataList}
          pagination={true}
          onChangePage={(e) => handleChanePageNo(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          totalRowCount={applicationMaintenanceList?.TotalRecordCount}
          currentPage={appmaintanence?.PageNo}
          paginationPerPage={appmaintanence?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={appmaintanence?.SortBy?.split(" ")[0]}
          sortDirection={appmaintanence?.SortBy?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(ApplicationMaintenance);
